import { faPencil } from '@fortawesome/pro-light-svg-icons/faPencil';
import { faTrashAlt } from '@fortawesome/pro-light-svg-icons/faTrashAlt';
import { Box } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { OrderItem as OrderItemModel, OrderStaff } from '@spike/order-model';
import clsx from 'clsx';
import OrderItemData from 'components/Checkout2/UI/OrderItemData';
import { FunctionComponent } from 'react';
import { ToolbarButton, ToolbarOption } from '../UI/ToolbarButton';

export interface OrderItemProps {
    type: string;
    orderItem: OrderItemModel;
    staff?: OrderStaff;
    editable: boolean;
    withoutOptions?: boolean;
    onEdit?: () => void;
    onDelete?: () => void;
    className?: string;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            display: 'flex',
            padding: '15px 0px',
            marginRight: 15
        },
        leftContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            maxWidth: '94%'
        },
        rightContainer: {
            display: 'flex',
            flex: 1,
            height: '100%',
            justifyContent: 'flex-end',
            alignItems: 'center'
        },
        statusButton: {
            marginRight: 8
        }
    })
);

export const OrderItem: FunctionComponent<OrderItemProps> = props => {
    const classes = useStyles();

    const toolbarOptions: Array<ToolbarOption> = [
        {
            id: 'edit',
            icon: faPencil,
            label: `Edit ${props.type.toLowerCase() === 'custom' ? 'Custom Item' : props.type}`,
            onClick: () => props.onEdit && props.onEdit()
        },
        {
            id: 'delete',
            icon: faTrashAlt,
            label: 'Delete',
            color: '#EF4F57',
            onClick: () => props.onDelete && props.onDelete()
        }
    ];

    return (
        <Box className={clsx(classes.container, props.className)}>
            <Box className={classes.leftContainer}>
                <OrderItemData
                    type={props.type}
                    orderItem={props.orderItem}
                    staff={props.staff}
                />
            </Box>
            <Box className={classes.rightContainer}>
                {props.editable && !props.withoutOptions && <ToolbarButton options={toolbarOptions} />}
            </Box>
        </Box>
    );
};

export default OrderItem;
